import React from "react";
import {
  IdCard, Printer, BookUser, Plane, Vote, ScrollText, Baby, PlaneTakeoff,
  TrainFront, Camera, GraduationCap, Award, Car, CreditCard, Wallet, FilePlus,
  FileText,
} from "lucide-react";

const map = {
  IdCard, Printer, BookUser, Plane, Vote, ScrollText, Baby, PlaneTakeoff,
  TrainFront, Camera, GraduationCap, Award, Car, CreditCard, Wallet, FilePlus,
};

export const ServiceIcon = ({ name, className = "w-5 h-5" }) => {
  const Icon = map[name] || FileText;
  return <Icon className={className} aria-hidden />;
};

export default ServiceIcon;
